type LogArguments = Parameters<(typeof console)['log']>;

// TODO Documentare
const DEBUG_KEY_LOG_PREFIX = 'FWEngineLogger_';

export function createBrowserLogger(options: {
  isActive: boolean;
  debugKey?: string;
}) {
  return {
    debug(...args: LogArguments) {
      if (DEBUG_KEY_LOG_PREFIX + (options.debugKey ?? 'all') in global) {
        console.log(...args);
      }
    },
    log(...args: LogArguments) {
      if (options.isActive) {
        console.log(...args);
      }
    },
    warn(...args: LogArguments) {
      if (options.isActive) {
        console.warn(...args);
      }
    },
    error(...args: LogArguments) {
      console.error(...args);
    },
  };
}
